import { Step, StepLabel, Typography } from '@mui/material'
import { Stepper } from '@mui/material'

import { FC } from 'react'
import { CREATE_CASE_STEPS } from '../../../../constants'

interface CaseStepperProps {
  activeStep: number
  onStepClick: (index: number) => void
}

const CaseStepper: FC<CaseStepperProps> = ({ activeStep, onStepClick }) => {
  return (
    <Stepper
      activeStep={activeStep}
      orientation="vertical"
      sx={{
        '& .MuiStepConnector-line': { minHeight: { xs: 16, md: 40 } }
      }}
    >
      {CREATE_CASE_STEPS.map(({ label, description }, index) => (
        <Step key={label} completed={false}>
          <StepLabel
            optional={
              activeStep === index && (
                <Typography variant="caption" color="inherit">
                  {description}
                </Typography>
              )
            }
            sx={{
              '&:hover': {
                cursor: 'pointer'
              }
            }}
            onClick={() => onStepClick(index)}
          >
            <Typography variant="subtitle1" color="inherit" fontWeight={500}>
              {label}
            </Typography>
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  )
}

export default CaseStepper
